import {Box, Container, Grid, useTheme, Typography} from '@mui/material';


const Bio = () => {
  const theme = useTheme();

  return (
    <Container sx={{ width: '100%', height: '100%' }} maxWidth="lg"> 
      <Grid container xs={12} width='70%' marginTop={20} marginBottom={10} spacing={5}>
        <Grid item xs={12} md={5}>
          <Box sx={{
              width:'100%', 
              height:'300px',
              border: '2px solid black'
          }}>
            I still looking for a cool picture.
          </Box>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography 
              variant='h1' 
              style={{ 
                  fontSize: theme.typography.title2.fontSize, 
                  marginTop: '10px' 
              }} 
              textAlign= "left"
          >
              RIO DWI PUTRA
          </Typography>
          <Typography 
              variant="body1" 
              textAlign="left"
              style={{ 
                  fontSize: theme.typography.subtitle1.fontSize, 
                  fontFamily: theme.typography.subtitle1.fontFamily, 
                  fontWeight: theme.typography.subtitle1.fontWeightThin,
                  letterSpacing: '2px'
          }}>
              <p>Rio is a data enthusiast who loves nothing more than diving deep into the world of data engineering and data warehousing. When Rio isn't busy wrangling data, you can find him building web applications that are as sleek and stylish as a unicorn in a tuxedo. Rumor has it that Rio has even found a way to merge their two passions into one magical creation: a data-driven web app that's more addictive than a bag of unicorn candy! <br></br> (Chat GPT generated Content :))</p>
          </Typography>

        </Grid>
      </Grid>
    </Container>
  );
};

export default Bio;
